module.exports = __webpack_public_path__ + "img/0Q3B7166_Wood.8b85febc.jpg";